import {Component, Inject, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';
import { RestoreStatus } from 'src/app/models/restores/restore-status';
import { FormUtilService } from 'src/app/services/util/form-util.service';

@Component({
  selector: 'app-redirection-dialog',
  templateUrl: './redirection-dialog.component.html',
  styleUrls: ['./redirection-dialog.component.scss'],
  standalone: false
})
export class RedirectionDialogComponent implements OnInit {

  title: string = translate('DIALOG.CONFIRMATION');
  message: string;
  proceedButtonText: string = translate('DIALOG.CONFIRM');
  cancelButtonText: string = translate('DIALOG.CANCEL');
  redirectTitle: string;
  redirectMsg:string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder,
    public matdialogRef: MatDialogRef<RedirectionDialogComponent>) {
  }

  ngOnInit(): void {
    this.title = this.data?.title || this.title;
    this.message = this.data?.message;
    this.redirectTitle = this.data?.redirectTitle;
    this.redirectMsg = this.data?.redirectMsg;
    this.proceedButtonText = this.data?.proceedButtonText;
  }

  dialogClose(): void {
    this.matdialogRef.close(true);
  }

}
